class QuoteManager {
    constructor(configuratorId) {
        this.configurator = $('body .pc-configurator-popup[data-configurator-id="' + configuratorId + '"]');
        this.configuratorId = configuratorId;
        this.ajaxManager = new AjaxManager();
        this.initSaveQuoteButton();
    }

    initSaveQuoteButton() {
        const $saveButton = this.configurator.find('.pc-save-quote-button');
        const $emailForm = this.configurator.find('.pc-quote-email-form');
        const $emailInput = this.configurator.find('.pc-quote-email-input');
        const $submitButton = this.configurator.find('.pc-quote-submit');
        const $message = this.configurator.find('.pc-quote-message');

        $saveButton.on('click', (e) => {
            e.preventDefault();
            if ($emailForm.hasClass('active')) {
                $emailForm.removeClass('active');
                $message.removeClass('error success').hide();
            } else {
                $emailForm.addClass('active');
                $emailInput.focus();
            }
        });

        $submitButton.on('click', () => { 
            const email = $emailInput.val();
            if (this.validateEmail(email)) {
                this.saveQuote(email);
                $message.removeClass('error success').hide();
            } else {
                this.showMessage('Please enter a valid email address', 'error');
            }
        });

        $(document).on('click', (e) => {
            if (!$(e.target).closest('.pc-quote-email-form, .pc-save-quote-button').length) {
                $emailForm.removeClass('active');
                $message.removeClass('error success').hide();
            }
        });
    }

    validateEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    getUserData($configuratorId, userEmail) {
        const button = $(`.pc-configurator-button[data-configurator-id="${$configuratorId}"]`);
        let userData = {};

        if(button.length) {

            userData.userEmail = userEmail;

            if(button.data('user-id')) {
                userData.userId = button.data('user-id');
                userData.userName = button.data('user-name');
                userData.isAdmin = button.data('is-admin');
            }else{
                userData.userId = 0;
                userData.userName = 'Unregistered user';
                userData.isAdmin = false;
            }

        }

        return userData;
    }

    showMessage(text, type = 'error') {
        const $message = this.configurator.find('.pc-quote-message');
        $message.removeClass('error success')
               .addClass(type)
               .text(text)
               .show();
    }

    collectQuantityData() {
        const currentQuantity = parseInt(this.configurator.find('.pc-quantity-input').val()) || 1;
        const $quantityTable = this.configurator.find('.pc-quantity-table');
        let quantities = [];

        if ($quantityTable.length) {
            const tableQuantities = Array.from($quantityTable.find('tbody tr:not(.pc-custom-quantity-row)'))
                .map(row => ({
                    qty: parseInt($(row).data('qty')),
                    price: parseFloat($(row).find('.pc-price-cell .price').text())
                }))
                .filter(item => !isNaN(item.qty))
                .sort((a, b) => a.qty - b.qty);

            if (tableQuantities.length) {
                const currentPrice = parseFloat(this.configurator.find('.pc-custom-quantity-row .pc-price-cell .price').text());

                if (currentQuantity >= tableQuantities[tableQuantities.length - 1].qty) {
                    quantities.push({
                        qty: tableQuantities[tableQuantities.length - 1].qty,
                        price: tableQuantities[tableQuantities.length - 1].price
                    });
                } else {
                    const lowerValue = tableQuantities.filter(item => item.qty < currentQuantity).pop();
                    const higherValue = tableQuantities.find(item => item.qty > currentQuantity);
                    
                    if (lowerValue) {
                        quantities.push(lowerValue);
                    }
                    quantities.push({
                        qty: currentQuantity,
                        price: currentPrice
                    });
                    if (higherValue) {
                        quantities.push(higherValue);
                    }
                }
            }
        }

        return {
            main_quantity: {
                qty: currentQuantity,
                price: parseFloat(this.configurator.find('.pc-cart-button').data('price'))
            },
            quantity_variants: quantities
        };
    }

    async saveQuote(userEmail) {
        try {
            const configuratorId = this.configurator.data('configurator-id');
            const { main_quantity, quantity_variants } = this.collectQuantityData();

            const options = this.collectOptions();
            const fileInput = this.configurator.find('.pc-file-upload-input')[0];
            
            const userData = this.getUserData(configuratorId, userEmail);

            const quantityVariantsJson = JSON.stringify(quantity_variants);

            const response = await this.ajaxManager.saveQuote({
                configuratorId,
                quantity: main_quantity.qty,
                quantity_price: main_quantity.price,
                quantity_variants: quantityVariantsJson,
                options,
                fileInput,
                ...userData
            });

            if (response.success) {
                if (response.data?.restore_link) {
                    const tempInput = document.createElement('input');
                    tempInput.value = response.data.restore_link;
                    document.body.appendChild(tempInput);
                    tempInput.select();
                    document.execCommand('copy');
                    document.body.removeChild(tempInput);
                }

                this.showMessage('Quote saved successfully! Link copied to clipboard', 'success');

                setTimeout(() => {
                    const $emailForm = this.configurator.find('.pc-quote-email-form');
                    const $emailInput = this.configurator.find('.pc-quote-email-input');
                    const $message = this.configurator.find('.pc-quote-message');
                    
                    $emailForm.removeClass('active');
                    $emailInput.val('');
                    $message.removeClass('error success').hide();
                }, 10000);
            } else {
                this.showMessage('Error saving quote: ' + (response.data?.message || 'Unknown error'), 'error');
            }
        } catch (error) {
            console.error('Error saving quote:', error);
            this.showMessage('Error saving quote. Please try again.', 'error');
        }
    }

    collectOptions() {
        const options = [];
        
        this.configurator.find('.pc-option').each((index, option) => {
            const $option = $(option);
            const optionTitle = $option.find('.pc-option-title').text().trim();
            const optionSlug = $option.data('option-slug');
            const optionId = $option.data('option-id');

            if ($option.hasClass('pc-option-pitch_print')) {
                const ppData = this.collectPitchPrintData($option, optionTitle, optionSlug, optionId);
                options.push(ppData);
                return;
            }

            if($option.hasClass('pc-option-gallery')) {
                const galleryData = this.collectGalleryData($option, optionTitle, optionSlug, optionId);
                options.push(galleryData);
                return;
            }

            if($option.hasClass('pc-option-user_input')) {
                const userInputData = this.collectUserInputData($option, optionTitle, optionSlug, optionId);
                options.push(userInputData);
                return;
            }
            
            const $activeValue = $option.find('.pc-option-value.active');
            let valueLabel = '';

            if ($activeValue.length) {

                if($option.hasClass('pc-option-size')) {
                    valueLabel = $activeValue.text().trim();
                } else {
                    valueLabel = $activeValue.find('.value-label, .text').text().trim();
                }
                
                options.push({
                    name: optionTitle,
                    slug: optionSlug,
                    value: valueLabel,
                    valueId: optionId + '_' + $activeValue.attr('data-index')
                });
            }else{
                options.push({
                    name: optionTitle,
                    slug: optionSlug,
                    value: '',
                    valueId: ''
                });
            }

        });

        return options;
    }

    collectUserInputData($option, optionTitle, optionSlug, optionId) {
        const $values = $option.find('.pc-option-value');
        let inputs = {};
        let valueIds = [];

        $values.each((_, value) => {
            let $value = $(value);
            let $input = $value.find('.input-wrapper input');
            let label = $value.find('.input-label-wrapper label').text().trim();
            let slug = $value.data('option-slug');
            let input_value = $input.val();
            let suffix = $value.find('.user-input-suffix').text().trim();
            input_value = (suffix) ? input_value + ' ' + suffix : input_value;
            let index = $value.data('index');
            
            valueIds.push(optionId + '_' + index);
            
            inputs[slug] = {
                label: label,
                value: input_value,
                slug: slug,
            };
        });

        return {
            name: optionTitle,
            type: 'user_input',
            slug: optionSlug,
            value: inputs,
            valueId: valueIds
        }
    }

    collectPitchPrintData($option, optionTitle, optionSlug, optionId) {
        const $dataContainer = this.configurator.find('#pp_data_container');
        const $activeValue = $option.find('.pc-option-value.active');

        let data = {
            projectId: $dataContainer.attr('data-project-id'),
            mainPreview: $dataContainer.attr('data-main-preview'),
            pdfUrl: $dataContainer.attr('data-pdf-url'),
            previews: JSON.parse($dataContainer.attr('data-previews') || '[]'),
            designId: this.configurator.find('.pc-customize-button').attr('data-pp-design-id')
        };

        let valueLabel = $option.find('.pc-option-pitch_print__value.active').attr('data-value');
        return {
            name: optionTitle,
            slug: optionSlug,
            value: valueLabel,
            valueId: optionId + '_' + $activeValue.attr('data-index'),
            type: 'pitch_print',
            ...data
        };
    }

    collectGalleryData($option, optionTitle, optionSlug, optionId) {

        const $activeValue = $option.find('.pc-option-gallery-section__value.active');
        const $activeSection = $activeValue.closest('.pc-gallery-section').attr('data-section');
        
        const mainValue = {
            value: $activeValue.find('.value-label').text().trim(),
            valueId: optionId + '_' + $activeSection + '_' + $activeValue.attr('data-index')
        };

        const hasSubvalues = $activeValue.data('subvalues') && $activeValue.data('subvalues').length > 0;
        
        if (hasSubvalues) {
            const $activeSubvalue = $option.find('.pc-option-value.pc-subvalue.active');
            if ($activeSubvalue.length) {
                return {
                    name: optionTitle,
                    slug: optionSlug,
                    type: 'gallery',
                    value: mainValue,
                    activeSubvalue: {
                        value: $activeSubvalue.find('.value-label').text().trim(),
                        valueId: optionId + '_' + $activeSection + '_' + $activeValue.attr('data-index') + '_' + $activeSubvalue.attr('data-subvalue-index')
                    }
                };
            }
        }

        return {
            name: optionTitle,
            slug: optionSlug,
            type: 'gallery',
            value: mainValue
        };
    }
} 